export default "__VITE_ASSET__da9b0f2a__"